import { gql } from '@apollo/client';
import { useApolloClient } from '@apollo/client/react';
import { Button } from '@repo/ui/Button';
import { useZodForm } from '@repo/hooks/useZodForm';

import { Form } from '@repo/ui/Form';

export interface DeleteIpAddressProps {
  loading: boolean;
  ipId: string;
  refetch: () => void;
}

const DeleteIpAddress = ({ ipId, refetch, loading }: DeleteIpAddressProps) => {
  const DELETE_ACCOUNT_ALLOWED_ACCESS_IP = gql`
    mutation DeleteAccountAllowedAccessIp($id: ID!) {
      deleteAccountAllowedAccessIp(id: $id) {
        accountAllowedAccessIp {
          id
        }
      }
    }
  `;

  const client = useApolloClient();
  const onSubmit = async () => {
    await client.mutate({
      mutation: DELETE_ACCOUNT_ALLOWED_ACCESS_IP,
      variables: {
        id: ipId,
      },
    });

    setTimeout(() => {
      refetch();
    }, 2000);
  };

  const form = useZodForm({
    onSubmit,
  });

  return (
    <>
      <Form {...form} column={1}>
        <Form.Success fixed={true}>IP address successfully deleted.</Form.Success>
        <Form.Error>
          Unable to delete IP address. Please try again later or contact support if error persists.
          error persists.
        </Form.Error>
        <Button
          size="sm"
          disabled={loading}
          type="submit"
          variant="danger-secondary"
          className="w-min"
        >
          Delete
        </Button>
      </Form>
    </>
  );
};

export default DeleteIpAddress;
